import Auth0 from 'auth0-js'
import store from 'store'
import { showSnack } from 'utils'

const getState = () => store.getState().user
export const getCurrentUserEmail = () => i.getIn(getState(), [ 'profile', 'email' ])

const auth0Domain = process.env.AUTH0_DOMAIN
const auth0Id = process.env.AUTH0_ID

export let processingHash = null

export let webAuth = null
initAuth0()

function initAuth0() {
  if(webAuth) return
  webAuth = new Auth0.WebAuth({
    domain: auth0Domain
    , clientID: auth0Id
    , responseType: 'token id_token'
    , redirectUri: `${window.location.protocol}//${window.location.host}/doLogin` // TODO?
    , scope: 'openid email'
  })
}

export function restoreState(reducer) {
  const { hash } = reducer || {}
  if(hash) {
    initAuth0() // parsing order...
    processHash(hash) // would call logout if invalid
  }
  return reducer
}

export function login({ email }) {
  return new Promise( (resolve, reject) => {
    webAuth.passwordlessStart({ email, connection: 'email', send: 'link' }, (err, res) => err ? reject(err) : resolve(res))
  })
}

export let fakeState = localStorage.getItem('profile:state') || 'need_application' // FAKE

export function processHash(hash) {
  const promise = new Promise( (resolve, reject) => webAuth.parseHash({ hash }, (err, res) => err ? reject(err) : resolve(res)))
    .then( (token) => {
      if(!token) return Promise.reject(new Error('Token missing'))
      const { email } = token.idTokenPayload
      store.dispatch({ type: 'user/LOGIN', data: { hash, profile: { email }, token: token } })
      return Promise.resolve({ state: fakeState }) // TODO api req
    })
    .then(updateProfileFromServer)
    .catch( (err) => {
      store.dispatch({ type: 'user/LOGOUT' })
      return Promise.reject(err)
    })
  processingHash = promise.finally( () => {
    if(promise === processingHash) processingHash = null
  })
  return promise
}

export function updateProfileFromServer(data) {
  console.warn('updateProfileFromServer is fake')
  if(data.state) fakeState = data.state
  store.dispatch({ type: 'user/SET_PROFILE', data })
}

export function processLoginCallback() {
  const hash = window.location.hash
  window.location.hash = ''
  return processHash(hash)
    .then( () => m.route.set('/'))
    .then( () => setTimeout( () => {
      const toast = document.createElement('div')
      toast.innerText = `Welcome! Using a private device and don't want to have to do that again for a while?`
      const button = document.createElement('button')
      button.innerText = 'Click here' // TODO FINDME cleanup on timeout, but not if mouse over?
      button.style.border = 'none'
      button.style.background = 'none'
      button.style.textDecoration = 'underline'
      button.style.color = 'inherit'
      button.style.cursor = 'pointer'
      button.onclick = () => {
        // TODO
        store.dispatch({ type: 'config/SET_STORE_DATA', data: true })
        cleanup()
        const cleanupDone = showSnack('Done :-)')
        setTimeout(cleanupDone, 2e3)
      }
      toast.append(button)
      document.body.append(toast)
      const cleanupSnack = showSnack(toast)
      setTimeout(cleanup, 10e3)
      function cleanup() {
        if(cleanupSnack) {
          cleanupSnack()
        }
        try {
          toast.remove()
        } catch(e) {}
      }
    }, 0)) // race with mithril replacing the body
    .catch( (err) => {
      if(err.message !== 'Token missing') alert(err.message || err.errorDescription || err) // TODO
      m.route.set('/login')
    })
}

export function logout() {
  logoutAsync().catch( () => null)
  store.dispatch({ type: 'user/LOGOUT' })
  m.route.set('/')
}

export function logoutAsync() {
  return fetch(`https://${auth0Domain}/v2/logout`) // TODO
}

export default function user(state = { loggedIn: false, sudoMode: false, profile: {}, token: null, hash: null }, { type, data }) {
  if(type === 'user/LOGIN') {
    return i.assign(state, { activelyLoggedOut: false, loggedIn: true, ...data })
  }
  if(type === 'user/SET_PROFILE') {
    localStorage.setItem('profile:state', data.state) // FAKE - delete when there's a persistence store
    return i.assign(state, { profile: i.assign({ email: state.profile.email }, data) })
  }
  if(type === 'user/ENTER_SUDO_MODE') {
    return i.assign(state, { sudoMode: true })
  }
  if(type === 'user/EXIT_SUDO_MODE') {
    return i.assign(state, { sudoMode: false })
  }
  if(type === 'user/LOGOUT') {
    localStorage.removeItem('profile:state') // FAKE
    return i.assign(state, { hash: null, profile: {}, token: null, loggedIn: false, sudoMode: false, activelyLoggedOut: true })
  }
  return state
}

